import React from 'react';
import {Component} from 'react';
import "../../styles/components/_facility-card.scss";
import BlankComponent from "../BlankComponent/BlankComponent";

const convertTo12HourTime = (time) => {
    let hours;
    let minutes;
    let meridiem;
    try{
         hours = time.slice(0, 2);
         minutes = time.slice(2, 4);
         meridiem = (hours >= 12) ? 'p.m.' : 'a.m.';

        if (hours > 12) {
            hours = hours - 12;
        }

        if (hours === '00') {
            hours = 12;
        }
    }catch (e){
         hours = "closed";
         minutes = "";
         meridiem = "";
    }

    return {
        hours,
        minutes,
        meridiem
    }
};

class FacilityCard extends Component {

     getHoursView(operatingHour, index) {

        let startTime;
        let endTime;

        if (operatingHour.is24HourFacility === "false") {
            startTime = convertTo12HourTime(operatingHour.startTime);
            endTime = convertTo12HourTime(operatingHour.endTime);
        }
        if (operatingHour.is24HourFacility === "true") {
            return (
                    <td key={index}>
                        <span>24 hours</span>
                    </td>
            );
        }
        else if (operatingHour.startTime === "") {
            return (
                    <td key={index}>
                        <span>Closed</span>
                    </td>
            );
        }
        else {
            return (
                    <td key={index}>
                        <span>{startTime.hours}{startTime.minutes ? `:${startTime.minutes}` : ''} {startTime.meridiem}</span> <br></br>
                        <span>&mdash;</span><br></br>
                        <span>{endTime.hours}{endTime.minutes ? `:${endTime.minutes}` : ''} {endTime.meridiem}</span>
                    </td>
            )
        }
    }

    static formatPhoneAndTax(numberString) {
        var cleaned = ('' + numberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '');
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
    }

    addContactsToFacilitiesData(facilities, contacts) {

        for (const facility of facilities) {
            facility["airportContacts"] = [];
            for (const contact of contacts) {
                if (contact.manages.includes(facility.airportCodeIATA)) {
                    if (!facility["airportContacts"].includes(contact)) {
                        facility["airportContacts"].push(contact);
                    }
                }
            }
        }
    }


    render() {
        const { facilities, contacts } = this.props;

        this.addContactsToFacilitiesData(facilities, contacts);
        return (
                this.props.facilities ? facilities.map((airport, i) => (
                        <React.Fragment key={airport.id}>
                            {(i !== 0) && (i % 3 === 0) ? <div className="page-break"/> : null }
                            <div className="facility-card-container">
                                <div id={'facility-' + airport.id}>
                                    <div className="facility-card-airport-title">{airport.airportCodeIATA} - {airport.airportName}</div>
                                    <div className="facility-card-container-row">
                                        <div className="facility-card-container-columns" >
                                            <div className="facility-card-text">{airport.facilityInfo.location.streetAddress1} <br></br>
                                                {airport.facilityInfo.location.streetAddress2 ? <p className="facility-card-streetAddressTwo">{airport.facilityInfo.location.streetAddress2}</p> : null}
                                                {airport.facilityInfo.location.cityName}{airport.facilityInfo.location.stateName ? ", " + airport.facilityInfo.location.stateName : null} {airport.facilityInfo.location.zipCode} <br></br>
                                                <span className="facility-card-bold-text">Tel: </span> {FacilityCard.formatPhoneAndTax(airport.facilityInfo.location.phoneNumber)} <br></br>
                                                <span className="facility-card-bold-text">Fax: </span> {FacilityCard.formatPhoneAndTax(airport.facilityInfo.location.faxNumber)} <br></br>
                                                <span className="facility-card-bold-text">Facility Resources: </span> {airport.facilityInfo.facilityCapabilityInfo.facilityResources && airport.facilityInfo.facilityCapabilityInfo.facilityResources.toLowerCase().includes("cooler") ? "COOLER" : "NO COOLER"}
                                            </div>
                                        </div>
                                        { airport.airportContacts ? airport.airportContacts.map((contact, index) => (
                                                        <div key={index} className="facility-card-container-columns">
                                                            <div className="facility-card-column-header">
                                                                {contact.title}
                                                            </div>
                                                            <div className="facility-card-text">{contact.name} <br></br>
                                                                {contact.phone} <br></br>
                                                                {contact.email}
                                                            </div>
                                                        </div>
                                                ))
                                                : null}
                                    </div>
                                    <div className="facility-card-container-table-row">
                                        <table className="facility-card-table">
                                            <thead>
                                            <tr>
                                                {
                                                    airport.facilityInfo.operatingHours.map((operatingHour, index) => {
                                                        return (
                                                                <BlankComponent key={index}>
                                                                    <th>{operatingHour.dayOfWeek}</th>
                                                                </BlankComponent>
                                                        )
                                                    })
                                                }
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                {
                                                    airport.facilityInfo.operatingHours.map((operatingHour, index) => {
                                                        return this.getHoursView(operatingHour, index)
                                                    })
                                                }

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )) : null

        )
    }
}

export default FacilityCard;



// WEBPACK FOOTER //
// ./src/components/FacilityCard/FacilityCard.js